import { handleJSON } from '@/utils/fetch-utils';
import { headers } from './index';

const { API_URL } = process.env;

export default {
  endpoints: {
    manageLearnersReportDownloads: `${API_URL}/manage-learners-downloaded-report/`,
  },

  fetchDownloads({ pageSize, currentPage, ordering, format = 'json', callback = handleJSON }) {
    const offset = currentPage * pageSize;

    let params = [
      {
        key: 'limit',
        value: pageSize,
      },
      {
        key: 'offset',
        value: offset,
      },
      {
        key: 'ordering',
        value: ordering,
      },
      {
        key: 'format',
        value: format,
      },
    ];

    params = [...params];

    params = params.map(param => `${param.key}=${param.value}`);
    const paramsQuery = params.join('&');
    const endpoint = `${this.endpoints.manageLearnersReportDownloads}?${paramsQuery}`;

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(callback);
  },
};
